import { queryOptions } from '@tanstack/react-query'

import { fetchCatalog } from '#admin/features/platform/payment-methods/api.ts'

export const catalogQuery = () =>
  queryOptions({
    queryKey: ['platform', 'payment-methods'],
    queryFn: ({ signal }) => fetchCatalog(signal),
    staleTime: 60_000,
  })
